// extracted by mini-css-extract-plugin
export default {"field_info_block__item":"FieldInfoBlock_field_info_block__item__YHz8R","spin":"FieldInfoBlock_spin__10Yze"};